<template>
  <div>
    <van-popup v-model="show" :overlay="false" position="top" :style="{ height: '100%', padding : '10px'}" :lock-scroll="true" :closeable="true" @close="close">
      <div style="height:40px;text-align:center;font-size:16px;line-height:36px;color:#EE7700">新增收货地址</div>
      <van-form @submit="onSubmit" ref="sSZAddressForm">
        <van-field required v-model="Name" name="Name" label="联系人" placeholder="请输入联系人" :rules="[{ required: true, message: '请填写联系人' }]" />
        <van-field required v-model="CompanyName" name="CompanyName" label="收货公司" placeholder="请输入收货公司" :rules="[{ required: true, message: '请填写收货公司' }]" />
        <van-field required v-model="Mobile" name="Mobile" label="手机号码" placeholder="请输入手机号码" :rules="[{ required: true, message: '请填写手机号码' }]" />

        <van-field  v-model="Phone" name="Phone" label="办公座机" placeholder="请输入办公座机" />

        <van-field readonly clickable name="area" :value="areaInfo" label="收货地址" placeholder="点击选择省市区" @click="showArea = true" />
        <van-popup v-model="showArea" position="bottom">
          <van-picker show-toolbar value-key="value" :columns="areaList" @confirm="areaSel" />
        </van-popup>

        <van-field required v-model="Address" name="Address" label="详细地址" placeholder="请输入详细地址" :rules="[{ required: true, message: '请填写详细地址' }]" />
        <van-field v-model="Remark" name="Remark" label="备注" placeholder="请输入备注" />

        <van-button round block type="info" native-type="submit" style="margin-top:30%;background-color:#EE7700;border:none;">提交</van-button>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { addShippingAddress } from "~/api/szDelivery";
import { getCityJsonData } from "~/utils/city";

export default {
  name: "AddView",
  components: {},
  data() {
    return {
      Id: 0,
      CompanyName: "",
      Name: "",
      Mobile: "",
      Phone: "",
      Type: null,
      Province: null,
      City: null,
      District: null,
      Address: "",
      Remark: "", // 收货时间
      IsDeleted: false,
      IsDefault: false,
      showArea: false,

      areaInfo: "",
      areaList: [],
    };
  },

  props: {
    show: Boolean,
    selectType: Number,
  },

  methods: {
    async onSubmit(data) {
      let loading = this.$toast.loading({
        message: "正在保存...",
        forbidClick: true,
        duration: 0,
      });
      try {
        data.Type=this.selectType;
        data.Province=this.Province;
        data.City=this.City;
        data.District=this.District;
        const res = await addShippingAddress(data);
        let fullAddress=this.areaInfo+this.Address;
        loading.clear();
        this.$emit("addressCb", { ShippingId: res,CompanyName:this.CompanyName,Name:this.Name,Mobile:this.Mobile,FullAddress: fullAddress});
      } catch {
        loading.close();
        Toast.fail("操作失败，请重试！");
      }
    },

    async close() {
      this.$emit("addressCb", null);
    },

    areaSel(obj,index) {
      this.areaInfo = obj.join("/")
      this.Province=this.areaList[index[0]].key;
      this.City=this.areaList[index[0]].children[index[1]].key;
      this.District=this.areaList[index[0]].children[index[1]].children[index[2]].key;
      this.showArea=false;
    },

    async getAreaList() {
      const data = await await getCityJsonData();
      let list = [];

      Object.keys(data[1]).forEach((k) => {
        let curPro = data[1][k];
        curPro.forEach((x) => {
          let p = { key: x.code, value: x.address };
          let child = [];

          let curCity = data[x.code];

          Object.keys(curCity).forEach((y) => {
            let c1 = {};
            let curCountry = null;

            let c1Child=[];
            if (x.code==120) {
              curCountry = data[curCity[y].key];
              c1 = { key: curCity[y].key, value: curCity[y].value };
            } else {
              curCountry = data[y];
              c1 = { key: y, value: curCity[y] };
            }

            Object.keys(curCountry).forEach((z) => {
              let c2 = {};
              if (curCity[y].key == 12016) {
                c2 = { key: curCountry[z].key, value: curCountry[z].value };
              } else {
                c2 = { key: z, value: curCountry[z] };
              }
              c1Child.push(c2);
            });
            c1.children=c1Child;
            child.push(c1);
          });

          p.children=child;
          list.push(p);
        });
      });

      this.areaList=list;
    },
  },

  watch: {
    show: {
      handler(v) {
        if (v) {
          this.$nextTick(() => {
            this.getAreaList();
            this.$refs.sSZAddressForm.resetValidation("");
          });
        }
      },
    },
  },
};
</script>

<style lang="less" scope></style>
